const availabilityData = [
  {
    sqFt: '1,300-6,100',
    addresses: [
      {
        title: '767 S. ALAMEDA',
        floorplans: [
          {
            name: 'RESTAURANT',
            download: '/floorplans/ROWDTLA_Availability_FP_retail-767SA_Suite112.pdf'
          },
          {
            name: 'RESTAURANT',
            download: '/floorplans/ROWDTLA_Availability_FP_retail-767SA_Suite116.pdf'
          }
        ]
      }
    ]
  },
  {
    sqFt: '10,000',
    addresses: [
      {
        title: '757 S. ALAMEDA',
        floorplans: [
          {
            name: 'RETAIL',
            download: '/floorplans/ROWDTLA_Availability_FP_retail-757SA_Suite100.pdf'
          },
          {
            name: 'RESTAURANT / BREWERY',
            download: '/floorplans/ROWDTLA_Availability_FP_retail-757SA_Suite100.pdf'
          }
        ]
      }
    ]
  },
  {
    sqFt: '2,000',
    addresses: [
      {
        title: '1318 E. 7TH',
        floorplans: [
          {
            name: 'RESTAURANT',
            download: '/floorplans/ROWDTLA_Availability_FP_retail-1318E7_Suite134.pdf'
          }
        ]
      }
    ]
  },
  {
    sqFt: '2,000',
    addresses: [
      {
        title: '1320 E. 7TH',
        floorplans: [
          {
            name: 'RESTAURANT',
            download: '/floorplans/ROWDTLA_Availability_FP_retail-1320E7_Suite140.pdf'
          }
        ]
      }
    ]
  }
];

export default availabilityData;
